export default "__VITE_ASSET__Dr37OAgU__"